import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import throttle from 'lodash/throttle';

import reducers from './reducers';
import { loadState, saveState } from './utils/localStorage';

const persistedState = loadState();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  persistedState,
  composeEnhancers(applyMiddleware(...[thunk]))
);

store.subscribe(
  throttle(() => {
    const state = store.getState();
    saveState({
      user: state.user,
      states: state.states
    });
  }, 1000)
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js